"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var Submenu_1 = __importDefault(require("../../common/SubMenu/Submenu"));
var icons_1 = __importDefault(require("../icons"));
var MenuTitle = function (props) {
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'header-menu' },
            props.alias ? (react_1.default.createElement(Submenu_1.default, { addMore: props.addMore, alias: props.alias, list: props.list, onAddClick: props.onAddClick, onChangeTab: props.onChangeTab, path: props.path })) : (react_1.default.createElement("div", { className: 'headerText' }, t(props.title))),
            !props.hideSave && (react_1.default.createElement("div", { className: 'header-save-button', onClick: props.onSave },
                react_1.default.createElement(icons_1.default, { className: 'icon_blue', height: 20, name: 'save', width: 20 }),
                react_1.default.createElement("a", { className: 'headerText margin-text' }, t('save')))))));
};
exports.default = MenuTitle;
